<!-- Hide settings if the ai sales assistant is turned off -->
@if ((salesCoachConfig$ | async)?.joinMeetings) {
  <!-- Recording Settings Card -->
  <mat-card appearance="outlined" class="step-card">
    <mat-card-header>
      <mat-card-title id="recording-settings">
        {{ 'MEETING_SCHEDULER.RECORDING_SETTINGS.TITLE' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <!-- Recording on/off section -->
      <mat-slide-toggle [formControl]="userConfigForm.controls.joinMeetings" (toggleChange)="userJoinMeetingsToggleChanged()">
        {{ 'MEETING_SCHEDULER.RECORDING_SETTINGS.RECORD_TOGGLE' | translate }}
      </mat-slide-toggle>

      <mat-divider class="setting-divider"></mat-divider>

      <!-- Privacy Settings Section -->
      <div class="title-and-learn-more">
        <div class="title">
          {{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.TITLE_V2' | translate }}
        </div>
        <div class="learn-more" (click)="learnMoreClicked()">
          {{ 'MEETING_SCHEDULER.RECORDING_SETTINGS.LEARN_MORE' | translate }}
          <mat-icon class="learn-more-info-icon">info_outline</mat-icon>
        </div>
      </div>
      @if (partnerName$ | async; as partnerName) {
        <form [formGroup]="userConfigForm" class="privacy-settings-form">
          <glxy-form-field class="privacy-select" [disabled]="!userConfigForm.controls.joinMeetings.value">
            <glxy-label>{{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.INTERNAL_MEETINGS_LABEL' | translate }}</glxy-label>
            <mat-select formControlName="internalMeetingVisibility"
                        [disabled]="!userConfigForm.controls.joinMeetings.value">
              <mat-option
                [value]="PrivacyLevel.PRIVACY_LEVEL_OPEN">{{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.OPTION_ALL_OF' | translate }} {{ partnerName }}
              </mat-option>
              <mat-option
                [value]="PrivacyLevel.PRIVACY_LEVEL_PRIVATE">{{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.OPTION_PRIVATE' | translate }}
              </mat-option>
            </mat-select>
            <glxy-hint>
              @if (userConfigForm.controls.internalMeetingVisibility.value === PrivacyLevel.PRIVACY_LEVEL_PRIVATE) {
                {{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.PRIVATE_HELP_TEXT_DYNAMIC_NAME' | translate: { namespaceName: partnerName } }}
              } @else {
                {{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.PUBLIC_HELP_TEXT_DYNAMIC_NAME' | translate: { namespaceName: partnerName } }}
              }
            </glxy-hint>
          </glxy-form-field>

          <glxy-form-field class="privacy-select" [disabled]="!userConfigForm.controls.joinMeetings.value">
            <glxy-label>{{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.EXTERNAL_MEETINGS_LABEL' | translate }}</glxy-label>
            <mat-select formControlName="externalMeetingVisibility"
                        [disabled]="!userConfigForm.controls.joinMeetings.value">
              <mat-option
                [value]="PrivacyLevel.PRIVACY_LEVEL_OPEN">{{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.OPTION_ALL_OF' | translate }} {{ partnerName }}
              </mat-option>
              <mat-option
                [value]="PrivacyLevel.PRIVACY_LEVEL_PRIVATE">{{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.OPTION_PRIVATE' | translate }}
              </mat-option>
            </mat-select>
            <glxy-hint>
              @if (userConfigForm.controls.externalMeetingVisibility.value === PrivacyLevel.PRIVACY_LEVEL_PRIVATE) {
                {{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.PRIVATE_HELP_TEXT_DYNAMIC_NAME' | translate: { namespaceName: partnerName } }}
              } @else {
                {{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.PUBLIC_HELP_TEXT_DYNAMIC_NAME' | translate: { namespaceName: partnerName } }}
              }
            </glxy-hint>
          </glxy-form-field>
        </form>
      }

      @if (showUserConfigSaveButton) {
        <div class="actions">
          <button mat-flat-button color="primary" (click)="SaveUserConfigSettings()"
                  [disabled]="userConfigForm.invalid || isSavingUserConfigForm || !userConfigForm.controls.joinMeetings.value">
            {{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.SAVE_BUTTON' | translate }}
          </button>
        </div>
      }
    </mat-card-content>
  </mat-card>

  @if (showNamespaceSettings) {
    <mat-card appearance="outlined" class="step-card">
      <mat-card-header>
        <mat-card-title>
          {{ "MEETING_SCHEDULER.NAMESPACE_SETTINGS.TITLE" | translate }}
          <glxy-badge [color]="'red'">{{ "MEETING_SCHEDULER.NAMESPACE_SETTINGS.TITLE_BADGE" | translate }}</glxy-badge>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="namespaceConfigForm">
          <glxy-form-field>
            <glxy-label>{{ "MEETING_SCHEDULER.NAMESPACE_SETTINGS.DISPLAY_NAME" | translate }}</glxy-label>
            <input type="text" matInput formControlName="notetakerName" placeholder="Notetaker"/>
            <glxy-hint>{{ "MEETING_SCHEDULER.NAMESPACE_SETTINGS.DISPLAY_NAME_HINT" | translate }}</glxy-hint>
          </glxy-form-field>
          <glxy-form-field>
            <mat-checkbox formControlName="showRecordingConsentMessages">
              {{ "MEETING_SCHEDULER.NAMESPACE_SETTINGS.CONSENT" | translate }}
            </mat-checkbox>
            <glxy-hint> {{ "MEETING_SCHEDULER.NAMESPACE_SETTINGS.CONSENT_HINT" | translate }}</glxy-hint>
          </glxy-form-field>
        </form>
        <div class="actions">
          <button mat-flat-button color="primary" (click)="SaveNamespaceConfigSettings()"
                  [disabled]="namespaceConfigForm.invalid || isSavingNamespaceConfigForm">
            {{ 'MEETING_SCHEDULER.PRIVACY_SETTINGS.SAVE_BUTTON' | translate }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  }
}
